import axios, { type AxiosRequestConfig } from 'axios'
import { getItem, removeItem } from './storage'

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 30000
})
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 请求成功做点什么
    // 设置统一token
    const token = getItem('token')
    if (token && config.headers) {
      config.headers.set('token', token)
    }
    return config
  },
  function (error) {
    // 对请求错误做点什么
    return Promise.reject(error)
  }
)
// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应成功做点什么
    const { success, message, data } = response.data
    if (success) {
      console.log('请求成功', data)
      return data
    } else {
      // 请求失败，业务失败，消息提示
      console.log('请求失败', message)
      return Promise.reject(new Error(message))
    }
  },
  function (error) {
    if (error.response?.status === 401) {
      removeItem('token')
      window.location.hash = '#/login'
    }
    return Promise.reject(error)
  }
)

export default async <T = any>(config: AxiosRequestConfig) => {
  const data = await instance(config)
  return data as T
}
